module.exports = __webpack_public_path__ + "img/bg-misi.c9a310b3.webp";